// src/services/contactsExportService.js
import { fetchWithAuth } from '../utils/fetchWithAuth';


const mapContact = (c = {}) => ({
  contact_name:  c.contact_name ?? c.name ?? c.full_name ?? '',
  title_job:     c.title_job ?? c.job_title ?? c.position ?? '',
  area:          c.area ?? c.department ?? '',
  email:         c.email ?? c.mail ?? '',
  phone_number:  c.phone_number ?? c.phone ?? c.mobile ?? c.telephone ?? '',
  id:            c.id ?? c._id,
  raw:           c,
});

const toArray = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (payload && typeof payload === 'object') {
    if (Array.isArray(payload.data))     return payload.data;
    if (Array.isArray(payload.contacts)) return payload.contacts;
    if (Array.isArray(payload.results))  return payload.results;
  }
  return [];
};

const fetchRawByName = async (name) => {
  const safe = encodeURIComponent(String(name ?? '').trim());
  if (!safe) return [];
  const res = await fetchWithAuth(`/contacts/company/${safe}`, { method: 'GET' });
  if (!res.ok) {
    if (res.status === 404) return []; // tolerar vacío
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}${text ? ` - ${text}` : ''}`);
  }
  return res.json();
};

/**
 * Devuelve SIEMPRE un array de contactos para una razón social (string).
 */
export const getContactsListByCompanyName = async (business_name) => {
  const payload = await fetchRawByName(business_name);
  return toArray(payload).map(mapContact);
};

/**
 * Versión "smart": acepta string o el OBJETO empresa completo.
 * 1) intenta business_name; si no hay resultados y hay trade_name, intenta trade_name.
 * 2) deduplica por id o por par (email + contact_name).
 */
export const getContactsListByCompanySafe = async (companyOrName) => {
  const name = typeof companyOrName === 'string'
    ? companyOrName
    : (companyOrName?.business_name ?? '');

  // 1) business_name
  let list = await getContactsListByCompanyName(name);

  // 2) fallback a trade_name si no hubo resultados
  if ((!list || list.length === 0) && typeof companyOrName !== 'string') {
    const alt = companyOrName?.trade_name;
    if (alt && alt !== name) {
      list = await getContactsListByCompanyName(alt);
    }
  }

  // 3) dedupe
  const seen = new Set();
  return list.filter((c) => {
    const key = c.id ? `id:${c.id}` : `k:${(c.email || '').toLowerCase()}|${(c.contact_name || '').toLowerCase()}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

/**
 * (Opcional) Trae un mapa { business_name: Contacto[] } para varias empresas.
 */
export const getContactsMapForCompanies = async (companies = []) => {
  const entries = await Promise.all(
    companies.map(async (co) => {
      const arr = await getContactsListByCompanySafe(co);
      return [co?.business_name ?? '', arr];
    })
  );
  return new Map(entries);
};
